<template>
  <div class="results-table__wrapper">
    <div  class="results-table">
      <table-header
        class="results-table__header"
        :tableConfig="tableConfig"
      />

      <table-data
        :tableConfig="tableConfig"
        :tableData="items"
      >
        <template v-slot:userState="c">
          <div class="results-table__cell">
            <button-watch
              :active="c.data.row.isWatched"
              class="result-item__watched"
              @click="onButtonWatchedClick(c.data.row.id, c.data.row.isWatched)"
            />

            <button-favorite
              class="result-item__favorite"
              :active="c.data.row.isFavorite"
              @click="onButtonFavoriteClick(c.data.row.id, c.data.row.isFavorite)"
            />
          </div>          
        </template>
      </table-data>
    </div>
  </div>
</template>

<script>
import clonedeep from 'lodash.clonedeep'

import { mapGetters } from 'vuex'

import ButtonFavorite from '@@/document/DocumentToolbar/ButtonFavorite';
import ButtonWatch from '@@/document/DocumentToolbar/ButtonWatch';

import SearchResultTableHeader from './SearchResultTableHeader';
import SearchResultTableData from './SearchResultTableData';

export default {
  components: {
    ButtonFavorite: ButtonFavorite,
    ButtonWatch: ButtonWatch,
    TableHeader: SearchResultTableHeader,
    TableData: SearchResultTableData
  },

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapGetters(['searchTableConfig']),
    tableConfig() {
      let newConfig = this.searchTableConfig
        // Добавление "иммутабельности" и порядкового номера в полном массиве
        .map( (item, num) => {
          let newItem = clonedeep(item)

          newItem.realNum = num

          return newItem 
        })
        // Отфильтровать только видимые колонки
        .filter( i => i.active)
        let totalWidth = newConfig.reduce((totalSum, item) => (totalSum + +item.colWidth), 0)

        newConfig.forEach( item => {
          item.style = Object.assign(item.style, {
            width: `${100 * item.colWidth / totalWidth}%`
          })
        })

      return newConfig
    }
  },

  methods: {
    onButtonFavoriteClick(id, status) {
      this.$emit('favorite-click', id, status)
    },
    onButtonWatchedClick(id, status) {
      this.$emit('watched-click', id, status)
    }
  }
};
</script>
